export const DEFAULT_SETTINGS = {
  passwordSaving: true,
  accountAutoSave: true,
  showReminder: true,
  passwordOptions: {
    isLeaked: true,
    isReused: true,
    isWeak: true,
  },
};

export const SUPPORTED_SAFARI_VERSION = 15;

export const VAULT_LOGIN_MAX_LENGTH = 254;
export const VAULT_PASSWORD_MAX_LENGTH = 512;
export const VAULT_NOTE_MAX_LENGTH = 4096;
